import { render } from "./datasetpreview.vue?vue&type=template&id=9290cf34&scoped=true"
import script from "./datasetpreview.vue?vue&type=script&lang=js"
export * from "./datasetpreview.vue?vue&type=script&lang=js"

import "./datasetpreview.vue?vue&type=style&index=0&id=9290cf34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9290cf34"]])

export default __exports__